import { MakeRequest } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';
import { UseMutationResult } from '@tanstack/react-query';
import { useState } from 'react';

export type UploadFileArgs = { formData: FormData; onUploadProgress?: (percent: number) => void };

export interface IUploadFileProps {
	uploadFileRequest?: MakeRequest<UploadFileArgs>;
	uploadFileQueryRequest?: UseMutationResult;
}

export const useUploadFile = ({ uploadFileRequest, uploadFileQueryRequest }: IUploadFileProps) => {
	const [percentComplete, setPercentComplete] = useState<number>(0);

	const onUpload = (file: File) => {
		const formData = new FormData();
		formData.append('file', file);
		formData.append('fileSize', file.size.toString());

		uploadFileRequest?.fetch({ formData, onUploadProgress: setPercentComplete });
		uploadFileQueryRequest?.mutate({ formData, onUploadProgress: setPercentComplete });
	};

	const isUploadError = uploadFileRequest?.isError;
	const isUploadSuccess = !isUploadError && !uploadFileRequest?.isLoading;

	return { percentComplete, setPercentComplete, onUpload, isUploadSuccess, isUploadError };
};
